<template>
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.61105 14.7123C6.22381 14.7123 4.86773 14.2934 3.71428 13.5084C2.56083 12.7234 1.66183 11.6077 1.13096 10.3023C0.600085 8.99693 0.461184 7.56053 0.731821 6.17475C1.00246 4.78897 1.67048 3.51605 2.6514 2.51696C3.63233 1.51787 4.8821 0.83748 6.24269 0.561832C7.60327 0.286183 9.01355 0.427656 10.2952 0.96836C11.5768 1.50906 12.6723 2.42471 13.443 3.59952C14.2137 4.77433 14.625 6.15552 14.625 7.56845C14.625 9.46313 13.8861 11.2802 12.5707 12.6199C11.2553 13.9597 9.47128 14.7123 7.61105 14.7123ZM1.99705 7.69169C2.01304 9.20196 2.61536 10.6444 3.67236 11.7037C4.72937 12.763 6.15511 13.353 7.63797 13.3449C9.12084 13.3368 10.5402 12.7311 11.586 11.6602C12.6317 10.5894 13.2187 9.14042 13.2187 7.63007C13.2187 6.11972 12.6317 4.67078 11.586 3.59993C10.5402 2.52908 9.12084 1.92339 7.63797 1.91525C6.15511 1.90711 4.72937 2.49717 3.67236 3.55648C2.61536 4.61578 2.01304 6.05819 1.99705 7.56845V7.69169ZM8.30905 11.1404H6.90905V8.28243H4.10405V6.85651H6.91005V3.99651H8.31005V6.85447H11.116V8.2804H8.31205L8.30905 11.1404Z"
            :fill="color || '#EC4B1D'"
        />
    </svg>
</template>
<script>
export default {
    name: "addFile",
    props: ["color"],
};
</script>


// WEBPACK FOOTER //
// src/components/V2/svg/components/AddFile.vue